<template>
  <div class="social-sharing">
    <p class="social-sharing-intro">
      {{ intro }}
    </p>
    <ul class="social-sharing-list">
      <li
        class="social-sharing-list-item"
      >
        <a
          :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`"
          target="_blank"
          rel="noopener noreferrer"
          class="social-sharing-list-link"
          :aria-label="`${i18n.socialSharing.shareThisArticle} Facebook`"
        >
          <facebook
            class="icon"
          />
        </a>
      </li>
      <li
        class="social-sharing-list-item"
      >
        <a
          :href="`https://twitter.com/intent/tweet?text=${url}`"
          target="_blank"
          rel="noopener noreferrer"
          class="social-sharing-list-link"
          :aria-label="`${i18n.socialSharing.shareThisArticle} Twitter`"
        >
          <Twitter
            class="icon"
          />
        </a>
      </li>
      <li
        class="social-sharing-list-item"
      >
        <a
          :href="`https://www.linkedin.com/cws/share?url=${url}`"
          target="_blank"
          rel="noopener noreferrer"
          class="social-sharing-list-link"
          :aria-label="`${i18n.socialSharing.shareThisArticle} Linkedin`"
        >
          <Linkedin
            class="icon"
          />
        </a>
      </li>
      <li
        class="social-sharing-list-item"
      >
        <kf-button
          :aria-label="i18n.socialSharing.copyLink"
          class="social-sharing-list-link"
          @click="copyToClipBoard(url)"
        >
          <LinkIcon
            v-if="!isCopied"
            class="icon"
          />
          <Checkmark
            v-else
            class="is-copied icon"
          />
        </kf-button>
      </li>
    </ul>
  </div>
</template>

<script>
import KfButton from '@/components/base/button/Button.vue';

export default {
  name: 'KfSocialSharing',
  components: {
    KfButton,
    Facebook: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Facebook.vue'),
    Twitter: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Twitter.vue'),
    Linkedin: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Linkedin.vue'),
    LinkIcon: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Link.vue'),
    Checkmark: () => import(/* webpackChunkName: "main"*/ '@/components/svg/Checkmark.vue')
  },
  props: {
    i18n: {
      type: Object,
      default: () => {},
    },
    intro: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: () => window.location.href.split('?')[0],
    },
  },
  data() {
    return {
      isCopied: false,
    };
  },
  methods: {
    async copyToClipBoard(value) {
      try {
        await navigator.clipboard.writeText(value);
        this.isCopied = true;
        setTimeout(() => (this.isCopied = false), 3000);
      } catch($e) {
        console('Cannot copy');
      }
    }
  },
};
</script>

<style lang="postcss">
.social-sharing {
  @apply border-t border-gray-50 pt-5 pb-10 gap-8;

  @screen md {
    @apply flex justify-end items-center;
  }

  &-intro {
    @apply text-base mb-4;

    @screen md {
      @apply mb-0;
    }
  }

  &-list {
    @apply flex items-center gap-8;

    &-item {
      @apply flex;
    }

    &-link {
      .icon {
        @apply w-5 h-5 text-primary-alpha;
        transition: color 200ms ease;

        &.is-copied {
          @apply text-success;
        }
      }

      &:hover {
        .icon {
          @apply text-primary-bravo;

          &.is-copied {
            @apply text-success;
          }
        }
      }
    }
  }
}
</style>
